// Admin Settings/Tools

<template>
	<div class="adm-settings-main" v-if="role=='adm'" >
		
		<div class="header wi8_font">
			Admin Settings/Tools
		</div>

		<div class="line">
			<div class="label">App Version</div>
			<div class="value">{{ appVersion }}</div>
			<div class="value">{{ appDate }}</div>
		</div>

		<div class="line">
			<div class="label">User Role</div>
			<div class="value">{{ role }}</div>
			<div class="action">
				<button @click="toggleRole">Set User Role</button>
			</div>
		</div>

		<div class="line">
			<div class="label">Show Debug</div>
			<div class="value">{{ debug.showConsoleMess }}</div>
			<div class="action">
				<button @click="toggleDebugConsoleMess">Set Debug Msgs</button>
			</div>
		</div>

		<div class="line">
			<div class="label">Data Source</div>
			<div class="value">{{ sourceName }}</div>
			<div class="action">
				<button @click="setDataSource">Set Data Source</button>
			</div>
		</div>

		<div class="line">
			<div class="label">Sweep</div>
			<div class="value"></div>
			<div class="action">
				<button @click="goSweep">Sweep Messages</button>
			</div>
		</div>

		<div class="line">
			<div class="label">Site Stats</div>
			<div class="value"></div>
			<div class="action">
				<button @click="goStats">Get Site Stats</button>
			</div>
		</div>


<!-- 
		<div class="line">
			<div class="label">Test</div>
			<div class="value"></div>
			<div class="action">
				<button @click="goTest">Go Test</button>
			</div>
		</div>
 -->

	</div>
</template>

<script>


import { m } from "@/utils/utils";
// import { m as n } from "@/utils/utils";
import { mapState, mapGetters } from "vuex";
import { eventBus } from "@/main";
export default {
	computed: {
		...mapGetters('app',['state']),
		...mapState('app',['role', 'debug', 'appVersion', 'appDate']),
		...mapState('api',['source', 'sourceName']),
	},
	methods: {
		goTest() {
			m("go test ===========================");

			const bag = ["tuna", "shrimp", "clams"];

			const basket = {
				milk: "skim",
				bananas: "yellow",
				pears: "Bartlett",
				apples: "Red",
				ok: true,
			}
			const newState = {...this.state};
		
			m( "groceries", bag, basket, this.state );

		},

		toggleDebugConsoleMess() {
			m("tools toggle debug mess");
			this.$store.dispatch("app/toggleDebugConsoleMess");
		},
		toggleRole() {
			m("tools toggle role");
			this.$store.dispatch("app/toggleRole");
		},
		setDataSource() {
			m("tools set data source");
			const data = {
				popType: "win",
				popTitle: "Data Sources",
				popText: "",
				compName: "AdmDataSource",
				compData: {
					curSourceName: this.sourceName,
				},
			};
			eventBus.$emit("popup", data);	
		},
		goSweep() {
			m("tools go sweep");
			const data = {
				popType: "win",
				popTitle: "Sweeping Messages",
				popText: "",
				compName: "UniPost",
				compData: {
					step: "sweep",
				},
			};
			eventBus.$emit("popup", data);	
		},
		goStats() {
			m("tools go stats");
			const data = {
				popType: "win",
				popTitle: "Site Statistics",
				popText: "",
				compName: "AdmStats",
				compData: {
				},
			};
			eventBus.$emit("popup", data);	
		},
	},
	created() {
		eventBus.$emit('popoffall'); // Close all modal windows
	},
}
</script>

<style scoped>
.adm-settings-main {
	height: 100%;
	overflow: hidden;
	color: #369;
	background-color: #F9FFF9;
	padding: 20px;
	border: solid 0px #090;
}

.header {
	height: 30px;
	overflow: hidden;
	text-align: center;
	color: #369;
	border: solid 0px #369;
}

.line {
	height: 30px;
	overflow: hidden;
	padding: 5px 0px 0px 0px;
	border: solid 0px #C30;
	border-bottom: solid 1px #999;
}

.label {
	display: inline-block;
	width: 90px;
	height: 25px;
	overflow: hidden;
	border: solid 0px #369;
}

.value {
	display: inline-block;
	width: 80px;
	height: 25px;
	overflow: hidden;
	font-weight: bold;
	color: #369;
	border: solid 0px #C30;
}

.action {
	display: inline-block;
	width: 130px;
	height: 25px;
	overflow: hidden;
	border: solid 0px #000;
}

button {
	width: 120px;
	text-align: left;
	padding: 1px 0px 1px 5px;
}


</style>
